import { useCallback } from "react";
import { Shared_Currencies } from "src/backend/openapi/v1";
import { useCurrencyT } from "src/translation-hooks/currency";

export const useCurrencyTranslation = () => {
  const t = useCurrencyT();

  const getCurrencyTranslation = useCallback(
    (state: Shared_Currencies) => {
      switch (state) {
        case Shared_Currencies.DKK:
          return t.dkk;
        case Shared_Currencies.EUR:
          return t.eur;
        case Shared_Currencies.USD:
          return t.usd;
        case Shared_Currencies.DEM:
          return t.dem;
        case Shared_Currencies.NOK:
          return t.nok;
        default:
          const assertNever: never = state;
          return assertNever;
      }
    },
    [t]
  );
  return { getCurrencyTranslation };
};
